import React, { useState } from "react";
import ClickNHold from "react-click-n-hold";
import { Modal } from "antd";
import { useSelector } from "react-redux";
import { MessageStatus } from "../../../constant/Types";
import VoicePlayer from "./VoicePlayer";
import {
  getHoursMinutesTime,
  trimDoubleQuotes,
} from "../../../constant/helper";
import AvatarPreview from "../../profile/components/AvatarPreview";
import MessageActions from "./MessageActions";
import MessageDateCategories from "./MessageDateCategories";
import { scrollTo } from "../utils/scrollTo";

const STATUS = {
  CREATED: "در حال برقراری تماس",
  PENDING: "در حال برقراری تماس",
  STARTING: "در حال برقراری تماس",
  STARTED: "در حال مکالمه",
  SIP_ERROR: "خطا در برقراری تماس",
  CLIENT_NOT_ANSWER: "خطا در برقراری تماس",
  LAWYER_NOT_ANSWER: "خطا در برقراری تماس",
  ENDED: "به پایان رسیده",
};

const CallMessage = ({
  time,
  data,
  status,
  meta,
  messageCancel,
  messageRetry,
  waveSurfer,
  pauseAll,
  messagesList,
  index,
  currentlyItem,
}) => {
  const { id } = meta;

  const { profile } = useSelector((state) => state);
  const [showDropdown, setShowDropdown] = useState(false);

  let statusResult =
    status === MessageStatus.sending || status === MessageStatus.failed
      ? status
      : "DONE";

  function cancel() {
    messageCancel(meta);
  }

  function retry() {
    messageRetry(meta.id);
  }

  const startShowDialog = () => {};
  const endShowDialog = () => {};
  const showDialog = () => {
    setShowDropdown(true);
  };

  if (
    data?.call?.status &&
    ["CREATED", "PENDING", "STARTING", "STARTED"].includes(data.call.status)
  ) {
    return <></>;
  }

  return (
    <>
      <div
        className={`msg msg-client-holder msg-voice  ${
          statusResult === "DONE" ? "msg-voice-done" : ""
        }`}
        id={id}
      >
        <MessageDateCategories
          className={{
            textAlign: "center",
            color: "#656567",
            fontWeight: "400",
            fontSize: "14px",
            marginBottom: "1rem",
          }}
          messagesList={messagesList}
          index={index}
          currentlyItem={currentlyItem}
        />
        <ClickNHold
          time={1} // Time to keep pressing. Default is 2
          onStart={startShowDialog}
          onClickNHold={showDialog}
          onEnd={endShowDialog}
          className="msg-wrapper"
        >
          <>
            <div className={"msg-avatar-bg"}>
              <div className={"msg-avatar-holder"}>
                <AvatarPreview
                  isSvg={false}
                  src={profile.data.extraInfo?.avatarImageUrl || "LAWONE"}
                />
              </div>
            </div>

            {data.inReplyToTheMessage && (
              <div
                className="msg-in-reply-text"
                onClick={() => scrollTo(data.inReplyToTheMessage.id)}
              >
                {trimDoubleQuotes(
                  data.inReplyToTheMessage.text ||
                    data.inReplyToTheMessage.filename
                )}
              </div>
            )}

            <div style={{ fontWeight: "bold" }}>تماس صوتی</div>
            {data?.call?.status && (
              <div>
                <span>وضعیت: </span>
                <span>{STATUS[data.call.status] || "نامشخص"}</span>
              </div>
            )}
            {!!data.link && (
              <VoicePlayer
                url={data.link}
                data={
                  meta && meta.temp
                    ? meta.temp
                    : typeof data === "string" && data !== ""
                    ? data
                    : ""
                }
                status={status}
                pauseAll={pauseAll}
                key={`voice-${
                  meta && meta.id ? meta.id : time
                }-${new Date().getTime()}`}
                keyName={`voice-${
                  meta && meta.id ? meta.id : time
                }-${new Date().getTime()}`}
                waveSurfer={waveSurfer}
                id={meta.id}
                cancel={cancel}
                retry={retry}
              />
            )}
            <div className={"msg-time"}>
              {" "}
              {time && getHoursMinutesTime(time)}{" "}
            </div>
          </>
        </ClickNHold>
      </div>

      <Modal
        open={showDropdown}
        onCancel={() => setShowDropdown(false)}
        centered
        footer={null}
        closable={false}
        wrapClassName="chat-modal-wrapper"
      >
        <MessageActions
          messageId={id}
          text={data.text || data.filename}
          closeActions={() => setShowDropdown(false)}
        />
      </Modal>
    </>
  );
};

export default CallMessage;
